<div class="redirect-container">
  <div class="redirect-content">
    @if (hasCustomLogoComponent$ | async) {
      <app-ovivio-logo [title]="logoTitle$ | async"></app-ovivio-logo>
    } @else {
      <img class="logo" [src]="logoUrl$ | async" alt="Logo" />
    }

    <div class="redirect-message">
      <h1>{{ 'redirect.heading' | translate }}</h1>
      <p [innerHTML]="'redirect.message' | translate: { targetUrl: targetUrl, countdown: countdown }"></p>
    </div>

    <div class="progress-container">
      <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
    </div>

    <button mat-raised-button color="primary" (click)="redirect()">
      {{ 'redirect.button' | translate }}
    </button>
  </div>
</div>
